<template>
  <div ref="grid" class="grid px-3 py-6" :style="{ height: ht }">
    <v-row>
      <v-col v-for="(item, i) in tableItems" :key="i" xxl="4" xl="4" lg="4" md="6" sm="6" xs="12">
        <v-card @click="$emit('rowClick', item)">
          <div
            v-if="item.type === 'FOLDER'"
            :class="{ 'grey lighten-3': !darkMode, 'grey darken-3': darkMode, 'text-center': true }"
            style="position: relative"
          >
            <v-icon style="font-size: 200px">
              {{ item.icon }}
            </v-icon>
            <div v-if="item.favorite || item.unread || item.tags.length > 0 || item.unconfirmed" :class="{ 'image-overlay pa-2': true, dark: darkMode }">
              <v-badge
                v-if="item.unread > 0"
                :color="theme.unreadBadgeColor"
                class="ml-2"
                :content="item.unread"
                :offset-x="item.unconfirmed === 0 ? '20' : '40'"
              >
              </v-badge>
              <v-badge v-if="item.unconfirmed > 0" :color="theme.toAcknowledgeBadgeColor" class="ml-2" :content="item.unconfirmed" offset-x="20">
              </v-badge>
              <v-icon v-if="item.tags.length > 0" color="grey" class="ml-2"> mdi-tag-multiple </v-icon>
              <v-icon v-if="item.favorite" :value="item.favorite" :color="theme.elements.activeColor" class="ml-2" inline>
                {{ mx_icons.favoriteIconActive }}
              </v-icon>
            </div>
          </div>

          <v-img v-else-if="item.type === 'ARTICLE' || item.type === 'IMAGE'" :src="getMediaUrl(item.mediaId)" height="200px" cover>
            <div v-if="item.favorite || item.unread || item.tags.length > 0 || item.unconfirmed" :class="{ 'image-overlay pa-2': true, dark: darkMode }">
              <v-icon v-if="item.unread && !item.unconfirmed" :color="theme.unreadBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
              <v-icon v-if="item.unconfirmed" :color="theme.toAcknowledgeBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
              <v-icon v-if="item.tags.length > 0" color="grey" class="ml-2"> mdi-tag-multiple </v-icon>
              <v-icon v-if="item.favorite" :value="item.favorite" :color="theme.elements.activeColor" class="ml-2" inline>
                {{ mx_icons.favoriteIconActive }}
              </v-icon>
            </div>
          </v-img>

          <div v-else :class="{ 'grey lighten-3': !darkMode, 'grey darken-3': darkMode, 'text-center': true }" style="position: relative">
            <v-icon style="font-size: 200px">
              {{ item.icon }}
            </v-icon>
            <div v-if="item.favorite || item.unread || item.tags.length > 0 || item.unconfirmed" :class="{ 'image-overlay pa-2': true, dark: darkMode }">
              <v-icon v-if="item.unread && !item.unconfirmed" :color="theme.unreadBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
              <v-icon v-if="item.unconfirmed" :color="theme.toAcknowledgeBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
              <v-icon v-if="item.tags.length > 0" color="grey" class="ml-2"> mdi-tag-multiple </v-icon>
              <v-icon v-if="item.favorite" :value="item.favorite" :color="theme.elements.activeColor" class="ml-2" inline>
                {{ mx_icons.favoriteIconActive }}
              </v-icon>
            </div>
          </div>

          <v-card-title class="body-1 ellipsis d-block"> {{ item.name }} </v-card-title>
          <v-card-subtitle class="ellipsis d-block">{{ item.description || '&nbsp;' }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';
import index from '@/modules/media';

export default {
  name: 'MediaModuleGridLayout',
  mixins: [common],
  props: {
    currentChildren: Object,
    tableItems: Array,
  },
  data() {
    return {
      ht: '100%',
      interval: null,
    };
  },
  computed: {
    ...mapState('media', ['mediasById', 'tagsById']),
  },
  methods: {
    getMediaUrl(mediaId) {
      let articleMediaUrl = '';
      let media = this.mediasById[mediaId];
      if (media && media.properties && media.properties.filename && media.properties.checksum) {
        articleMediaUrl = this.moduleFileUrl(index.moduleId, media.properties.filename, media.properties.checksum);
      }
      return articleMediaUrl;
    },
    handleResize() {
      if (this.$refs.grid) {
        const ht = window.innerHeight - this.$refs.grid.getBoundingClientRect().y - 54 + 'px';
        this.ht = ht;
      }
    },
  },
  watch: {
    currentChildren(to, from) {
      window.setTimeout(() => {
        this.handleResize();
      }, 500);
    },
  },
  mounted() {
    window.addEventListener('resize', setTimeout.bind(null, this.handleResize, 500));
    this.interval = setInterval(this.handleResize, 3000);
    window.setTimeout(() => {
      this.handleResize();
    }, 500);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    clearInterval(this.interval);
  },
};
</script>

<style>
.grid {
  overflow-y: auto;
  overflow-x: hidden;
}
.v-card {
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.24) 0px 2px 16px 0px !important;
}
.ellipsis {
  display: inherit;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.image-overlay {
  display: block;
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: right;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 100%);
}
.image-overlay.dark {
  background: rgb(0, 0, 0);
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
}
</style>
